import * as React from 'react';
import { getService, IService } from '../../API/GoMoto';
import { useAppointmentState, useAppointmentUpdateAndPersist } from '../../context/Appointment/appointment';
import { Types, useCart, useCartDispatch } from '../../context/cart';
import { useKioskLocalization, useKioskState } from '../../context/Kiosk/kiosk';
import { CTAButton } from '../../controls/ButtonBase';
import { useLocalization } from '../../context/Localization/localization';
import { Heading } from '../../controls/Heading/Heading';
import { getUpdateAptServices } from '../../helpers/Appointment';
import { ScrollableBody } from '../Layout/ScrollableBody/ScrollableBody';
import { GMButtonGroup } from '../../controls/ButtonGroup';
import { GMAppointmentName } from '../../controls/AppointmentName';

export interface IProps {
    onProceed: () => void;
    onSkip: () => void;
}
export const CustomUpsell: React.FC<IProps> = (props) => {
    const Localization = useLocalization();
    const kioskLocalization = useKioskLocalization();
    const kiosk = useKioskState();
    const cart = useCart();
    const appointment = useAppointmentState();
    const setAppointment = useAppointmentUpdateAndPersist();
    const [customService, setCustomService] = React.useState<IService>();
    const { customUpsellPageEnabled } = kiosk.dealer;
    const cartDispatch = useCartDispatch();

    React.useEffect(() => {
        if (!customUpsellPageEnabled) {
            props.onSkip();
        }
    }, [customUpsellPageEnabled, props]);

    const getTargetService = async () => {
        if (!customService) {
            const targetService = await getService(kiosk.key, kiosk.dealer.customUpsellOpCode);
            if (targetService) {
                setCustomService(targetService);

                return targetService;
            }
        }

        return customService;
    };
    const onProceed = async (addService: boolean) => {
        const service = await getTargetService();
        if (service) {
            cartDispatch({
                type: addService ? Types.AddService : Types.RemoveService,
                payload: service,
            });
            cartDispatch({
                type: addService ? Types.UpdateComment : Types.RemoveComment,
                payload: {
                    key: 'CustomUpsell',
                    comment: `Customer is interested in ${kiosk.dealer.customUpsellName}`,
                },
            });
            setAppointment({
                ...appointment,
                comment: cart.comments.map((c) => c.comment)
                    .join('; '),
                servicesConfirmed: getUpdateAptServices(cart.services),
            });
        }
        props.onProceed();
    };

    return customUpsellPageEnabled ? (
        <ScrollableBody
            heading={<Heading primaryHeading={<GMAppointmentName />} secondaryHeading={kioskLocalization.dealer.customUpsellPageText} />}
            proceedButtons={
                <GMButtonGroup
                    buttons={[
                        (
                            <CTAButton
                                styleType={'primary'}
                                onClick={() => onProceed(true)}
                                title={Localization.ClickToConfirmSpecialOffer}
                                label={Localization.Yes}
                                id={Localization.ClickToConfirmSpecialOffer}
                                ariaLabel={Localization.ClickToConfirmSpecialOffer}
                            />
                        ),
                        (
                            <CTAButton
                                styleType={'secondary'}
                                onClick={() => onProceed(false)}
                                title={Localization.ClickToSkipSpecialOffer}
                                label={Localization.No}
                                id={Localization.ClickToSkipSpecialOffer}
                                ariaLabel={Localization.ClickToSkipSpecialOffer}
                            />
                        ),
                    ]}
                />
            }
        />
    ) : null;
};
